import type { EmbargoCategoryConfig } from '../types';

export const normalizeEmbargoValue = (value: string | null | undefined): string =>
  (value ?? '').trim().toUpperCase();

export const isValueInList = (
  value: string | null | undefined,
  list: string[]
): boolean => {
  const normalized = normalizeEmbargoValue(value);
  if (!normalized || !list?.length) {
    return false;
  }
  return list.some((item) => normalizeEmbargoValue(item) === normalized);
};

export const isValueInCategory = (
  value: string | null | undefined,
  category: EmbargoCategoryConfig | null | undefined
): boolean => isValueInList(value, category?.values ?? []);
